import React from 'react';
import _     from 'lodash'

const text = (d) => {
  return `${_.replace(d, /MK|US/, '')} ${d === 1 ? 'day' : 'days'}`;
}

const PriceMatrixHead = (props) => {

  return (
    <thead>
      <tr>
        <th className="qty">Qty</th>
        {props.leadTimes.map(qty => <th key={qty}>{text(qty)}</th>)}
      </tr>
    </thead>
  );
};

PriceMatrixHead.defaultProps = {
  leadTimes: [],
};

export default PriceMatrixHead;
